'use strict';

frontendApp.directive('iioTag', ['$compile', 'TagService', 'TagCategoryService', function ($compile, TagService, TagCategoryService) {
  return {
    restrict: 'E',
    templateUrl: 'partials/tagging/tag.html',
    scope: {
      project: '=',
      tag: '=',
      index: '@'
    },

    link: function (scope, element, attrs) {

      scope.category = {};

      scope.$watch('tag', function (tag) {
        if (tag) {
          TagCategoryService.findById(tag.categoryId, function (category) {
            scope.category = category;
          });
        }
      });

      // Can remove tag?
      if (attrs.remove) {
        scope.removeType = attrs.remove;
      } else {
        scope.removeType = "any";
      }

      scope.removeFromList = function () {
        // We could be un-tagging a resource,
        // Deleting a tag permanently
        // Removing a tag from a boolean thing...
        // Something i can't think of... so we just emit and let someone else handle it

        scope.removing = true;
        scope.$emit('RemoveTag', scope.tag, scope.index);
      };

    }
  }
}]);
